export const DEBUG = false; 
// export const PATH = 'https://hatannapi.scriptales.com/'; 
export const PATH = 'https://api.hatannapp.fr/'; 